export const SORT_BY = {
    ID: 'c.id',
    FULL_NAME: 'fullName',
};
